import "./App.css";
import React from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useDispatch, useSelector } from "react-redux";

import Snackbar from "./component/LayoutElements/Notification";
import { hideToast } from "./store/actions";
import Route from "./route";
const mdTheme = createTheme({
  palette: {
    primary: {
      light: "#ff9800",
      main: "#3a3d4a",
      dark: "#e65100",
    },
    secondary: {
      light: "#90a4ae",
      main: "#3a3d4a",
      dark: "#263238",
      text: "#f5f5f5",
    },
    TiffanyBlue: {
      main: "#e8edf1",
      gradient: "linear-gradient(320deg, rgba(58,61,74,1) 0%, rgba(232,237,241,1) 75%)"
    },
    dark: {
      light: "#637282",
      main: "#373f48",
      dark: "#0b0d0e",
      text: "#fff",
    },
    success: {
      light: "#B4CAB6",
      main: "#1B5E20",
      dark: "#0E3011",
    },
  },
});

function App() {
  //For Toastes
  const {
    toast: { message, type = "primary", visible },
  } = useSelector((state) => state);

  const dispatch = useDispatch();

  return (
    <ThemeProvider theme={mdTheme}>
      <Route />
      {visible && <Snackbar message={message} type={type} open={visible} onClose={() => dispatch(hideToast())} />}
    </ThemeProvider>
  );
}

export default App;
